import { render, staticRenderFns } from "./ContactsDialog.vue?vue&type=template&id=5c78bfa0&scoped=true"
import script from "./ContactsDialog.vue?vue&type=script&lang=js"
export * from "./ContactsDialog.vue?vue&type=script&lang=js"
import style0 from "./ContactsDialog.vue?vue&type=style&index=0&id=5c78bfa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c78bfa0",
  null
  
)

export default component.exports